import React from 'react';

import PropTypes from 'prop-types';

import './TwoColumnLayout.scss';

export const TwoColumnsLayout = ({
  leftColumn = null,
  rightColumn = null,
  outerTopContent = null,
  noRightMargin = false
}) => (
  <>
    {outerTopContent}
    <div className="layout-outer-container">
      <div className="layout-two-column-inner-container">
        <div className="layout-two-column-main-content">{leftColumn}</div>
        <div className={`layout-two-column-sidebar-content ${noRightMargin ? 'no-right-margin' : ''}`}>{rightColumn}</div>
      </div>
    </div>
  </>
);

TwoColumnsLayout.propTypes = {
  leftColumn: PropTypes.node,
  rightColumn: PropTypes.node,
  outerTopContent: PropTypes.node,
  noRightMargin: PropTypes.bool,
};
TwoColumnsLayout.defaultProps = {
  leftColumn: null,
  rightColumn: null,
  outerTopContent: null,
  noRightMargin: false,
};
